import { createBrowserRouter } from 'react-router-dom'

import App from '../App';
import PravicyProtocol from '../components/PravicyProtocol';
import UserProtocol from '../components/UserProtocol';
import About from "../pages/about"
const router = createBrowserRouter([
  {
    path: "/",
    element: <App></App>
  },
  {
    path: "/pravicyprotocol",
    element: <PravicyProtocol></PravicyProtocol>
  },
  {
    path: "/userprotocol",
    element: <UserProtocol></UserProtocol>
  },
  {
    path: "/about",
    element: <About></About>
  }
])

export default router;